
const routes = [
  {
    path: '/test/features/dashboard',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-dashboard" */'@module/dashboard'),
    permissions: [],
  },
  {
    path: '/',
    module: import(/* webpackChunkName: "module-main" */'@module/main'),
    permissions: [],
  },
  {
    path: '/offer',
    wrapper: 'empty',
    module: import(/* webpackChunkName: "module-offer" */'@module/offer'),
    permissions: [],
  },
  {
    path: '/sign-in',
    module: import(/* webpackChunkName: "module-sign-in" */'@module/sign-in'),
  },
  {
    path: '/sign-up',
    module: import(/* webpackChunkName: "module-sign-up" */'@module/sign-up'),
    permissions: [],
  },
  {
    path: '/confirm',
    wrapper: 'empty',
    module: import(/* webpackChunkName: "module-confirm" */'@module/confirm'),
    permissions: [],
  },
  {
    path: '/getting-started',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-getting-started" */'@module/getting-started'),
    permissions: [],
  },
  {
    path: '/whats-new',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-instruction" */'@module/instruction'),
    permissions: [],
  },
  {
    path: '/warning',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-warning" */'@module/warning'),
    permissions: [],
  },
  {
    path: '/shops/inactive',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-shops" */'@module/shops'),
    permissions: ['shop.list'],
  },
  {
    path: '/shops/:id',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-shop-modify" */'@module/shop-modify'),
    permissions: ['shop.get'],
  },
  {
    path: '/shops',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-shops" */'@module/shops'),
    permissions: ['shop.list'],
  },
  {
    path: '/operations/invoices',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-invoices" */'@module/invoices'),
    permissions: ['operation.get'],
  },
  {
    path: '/operations/invoices/:uuid',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-invoice-details" */'@module/invoice-details'),
    permissions: ['operation.get'],
  },
  {
    path: '/operations/payouts',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-payouts" */'@module/payouts'),
    permissions: ['operation.get'],
    userType: ['INDIVIDUAL', 'LEGAL', 'ST'],
  },
  {
    path: '/operations/payouts/:uuid',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-payout-details" */'@module/payout-details'),
    permissions: ['operation.get'],
    userType: ['INDIVIDUAL', 'LEGAL', 'ST'],
  },
  {
    path: '/accounts/inactive',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-accounts" */'@module/accounts'),
    permissions: ['shop.balances.get'],
    userType: ['INDIVIDUAL', 'LEGAL', 'ST'],
  },
  {
    path: '/accounts',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-accounts" */'@module/accounts'),
    permissions: ['shop.balances.get'],
    userType: ['INDIVIDUAL', 'LEGAL', 'ST'],
  },
  {
    path: '/billing/operations',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-operations" */'@module/operations'),
    permissions: ['billing.operation.get'],
  },
  {
    path: '/billing/reports',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-reports" */'@module/reports'),
    permissions: ['billing.operation.get'],
  },
  {
    path: '/acts',
    wrapper: 'navigate',
    module: import(
      /* webpackChunkName: "module-acts" */'@module/acts'
      ),
    permissions: ['act.get'],
    userType: ['LEGAL', 'ST'],
  },
  // {
  //   path: '/about',
  //   wrapper: 'navigate',
  //   module: import(/* webpackChunkName: "module-about" */'@module/about'),
  //   permissions: ['merchant.get'],
  // },
  {
    path: '/faq',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-getting-started" */'@module/faq'),
    permissions: [],
  },
  {
    path: '/options',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-options" */'@module/options'),
    permissions: ['user.get'],
  },
  {
    path: '/finance',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-finance" */'@module/finance'),
    permissions: ['finance.get'],
  },
  {
    path: '/notifications',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-notifications" */'@module/notifications'),
    permissions: ['notification.get'],
  },

  {
    path: '/set/password',
    module: import(/* webpackChunkName: "module-set-password" */'@module/set-password'),
    permissions: [],
  },
  {
    path: '/reset/password',
    module: import(/* webpackChunkName: "module-reset-password" */'@module/reset-password'),
    permissions: [],
  },
  {
    path: '/*',
    wrapper: 'navigate',
    module: import(/* webpackChunkName: "module-not-found" */'@module/not-found'),
    permissions: [],
  }
];

export default routes;
